import { ButtonV2 } from "../ButtonV2/ButtonV2";
import { InputV2 } from "../InputV2/InputV2";

type BookingLimitStepperProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  isDisabled?: boolean;
  min?: number;
};

export function BookingLimitStepper({
  label,
  value,
  onChange,
  isDisabled = false,
  min = 1,
}: BookingLimitStepperProps) {
  return (
    <div className="mt-2">
      <p className="text-sm font-extrabold">{label}:</p>
      <div className="mt-1 flex items-center space-x-2">
        <ButtonV2
          onClick={() => onChange(Math.max(min, value - 1))}
          variant="outline"
          size="icon"
          disabled={isDisabled || value <= min}
          type="button"
        >
          -1
        </ButtonV2>
        <InputV2
          type="number"
          min={min}
          className="w-24 text-center"
          value={String(value)}
          onChange={(e) => {
            const n = parseInt(e.target.value, 10);
            if (Number.isNaN(n)) {
              return;
            }
            onChange(Math.max(min, n));
          }}
          disabled={isDisabled}
        />
        <ButtonV2
          onClick={() => onChange(value + 1)}
          variant="outline"
          size="icon"
          disabled={isDisabled}
          type="button"
        >
          +1
        </ButtonV2>
      </div>
    </div>
  );
}
